import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Typography, useTheme } from '@qbe/ads-core';
import React from 'react';

import Modal from '~/components-ds/Modal';
import { useAppContent } from '~/hooks';

interface PaymentSessionRefreshModalProps {
  open: boolean;
  onContinue: () => void;
}

const PaymentSessionRefreshModal = ({ open, onContinue }: PaymentSessionRefreshModalProps) => {
  const theme = useTheme();
  const { getTextContent: getSharedContent } = useAppContent({ basePath: 'shared' });
  const { getTextContent } = useAppContent({ basePath: 'dsme.creditCardForm' });

  return (
    <Modal
      id="session-timeout-modal"
      open={open}
      iconProps={{
        muiIcon: InfoOutlined,
        color: theme.palette.info.main,
      }}
      primaryBtnProps={{
        label: getSharedContent('continueModalButtonLabel'),
        onClick: onContinue,
        'data-track': 'continue',
      }}
      title={getTextContent('title')}
      analyticsModalName="Payment Session Refresh Modal"
    >
      <Typography>{getTextContent('description')}</Typography>
    </Modal>
  );
};

export default PaymentSessionRefreshModal;
